import React from "react";
import sanchu_icon from "assets/images/sanchu_icon.svg";
export function MainLayout(props) {
  return (
    <div className="authLayout">
      <div className="login-wrapper">
        <div className="container-fluid">
          <div className="row no-gutter">
            <div className="col-md-8 col-lg-12">
              <div className="d-flex align-items-center py-3">
                <div className="container">
                  <div className="row py-5">
                    <div className="col-md-12 col-lg-12 mx-auto">
                      <div className="d-flex justify-content-center">
                        <img src={sanchu_icon} alt="Sanchu" width={"20%"} />
                      </div>
                      {props.children}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
